<template>
  <fieldset v-if="requiredLocationFields" class="t-flex-col t-max-w-sm t-space-y-2 t-mx-auto">
    <div v-if="requiredLocationFields.name" class="t-flex-col t-mb-1">
      <label for="location-name" class="t-flex t-mb-1 t-text-md t-font-bold t-text-gray-800 t-text-left">
        Location Name *
      </label>
      <input
        v-model="location.name"
        v-validate="{ required: requiredLocationFields.name }"
        type="text"
        name="location-name"
        id="location-name"
        class="t-w-full t-rounded-md t-font-normal t-shadow-sm t-border t-border-gray-400
                t-py-1 t-px-2 focus:t-outline-none focus:t-border-indigo-400"
        :class="{ 't-border-red-700': errors.has('location-name')}"
      >
      <span v-if="errors.has('location-name')" class="t-text-red-600 t-font-medium t-text-sm t-tracking-wide">
        Please enter the name of the location
      </span>
    </div>

    <div v-if="requiredLocationFields.address.street_number" class="t-flex-col t-mb-1">
      <label for="street-number" class="t-flex t-mb-1 t-text-md t-font-bold t-text-gray-800 t-text-left">
        Street Number *
      </label>
      <input
        v-model="location.address.street_number"
        v-validate="{ required: requiredLocationFields.address.street_number }"
        type="text"
        name="street-number"
        id="street-number"
        class="t-w-full t-rounded-md t-font-normal t-shadow-sm t-border t-border-gray-400
                t-py-1 t-px-2 focus:t-outline-none focus:t-border-indigo-400"
        :class="{ 't-border-red-700': errors.has('street-number')}"
      >
      <span v-if="errors.has('street-number')" class="t-text-red-600 t-font-medium t-text-sm t-tracking-wide">
        Please enter a street number
      </span>
    </div>

    <div v-if="requiredLocationFields.address.street_name" class="t-flex-col t-mb-1">
      <label for="street-name" class="t-flex t-mb-1 t-text-md t-font-bold t-text-gray-800 t-text-left">
        Street Name *
      </label>
      <input
        v-model="location.address.street_name"
        v-validate="{ required: requiredLocationFields.address.street_name }"
        type="text"
        name="street-name"
        id="street-name"
        class="t-w-full t-rounded-md t-font-normal t-shadow-sm t-border t-border-gray-400
                t-py-1 t-px-2 focus:t-outline-none focus:t-border-indigo-400"
        :class="{ 't-border-red-700': errors.has('street-name')}"
      >
      <span v-if="errors.has('street-name')" class="t-text-red-600 t-font-medium t-text-sm t-tracking-wide">
        Please enter a street name
      </span>
    </div>

    <div v-if="requiredLocationFields.address.suburb" class="t-flex-col t-mb-1">
      <label for="suburb" class="t-flex t-mb-1 t-text-md t-font-bold t-text-gray-800 t-text-left">
        Suburb *
      </label>
      <input
        v-model="location.address.suburb"
        v-validate="{ required: requiredLocationFields.address.suburb }"
        type="text"
        name="suburb"
        id="suburb"
        class="t-w-full t-rounded-md t-font-normal t-shadow-sm t-border t-border-gray-400
                t-py-1 t-px-2 focus:t-outline-none focus:t-border-indigo-400"
        :class="{ 't-border-red-700': errors.has('suburb')}"
      >
      <span v-if="errors.has('suburb')" class="t-text-red-600 t-font-medium t-text-sm t-tracking-wide">
        Please enter a suburb
      </span>
    </div>

    <div v-if="requiredLocationFields.address.city" class="t-flex-col t-mb-1">
      <label for="city" class="t-flex t-mb-1 t-text-md t-font-bold t-text-gray-800 t-text-left">
        City *
      </label>
      <input
        v-model="location.address.city"
        v-validate="{ required: requiredLocationFields.address.city }"
        type="text"
        name="city"
        id="city"
        class="t-w-full t-rounded-md t-font-normal t-shadow-sm t-border t-border-gray-400
                t-py-1 t-px-2 focus:t-outline-none focus:t-border-indigo-400"
        :class="{ 't-border-red-700': errors.has('city')}"
      >
      <span v-if="errors.has('city')" class="t-text-red-600 t-font-medium t-text-sm t-tracking-wide">
        Please enter a city
      </span>
    </div>

    <div class="t-flex t-justify-between">
      <button
        @click.prevent="onCancel"
        class="t-bg-gray-700 t-font-semibold t-rounded-md t-px-2 t-py-1 t-text-white t-text-lg t-mt-4"
      >
        Back To Search
      </button>
      <button
        @click.prevent="onConfirmForm"
        class="t-bg-blue-500 t-font-semibold t-rounded-md t-px-2 t-py-1 t-text-white t-text-lg t-mt-4"
      >
        Next
      </button>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'EnterManualLocationForm',
  description: '',
  props: {
    requiredLocationFields: {
      type: Object
    },
    /**
     * An object that may contain some location address fields that have already been found.
     */
    locationData: {
      type: Object
    }
  },
  emits: ['validManualLocation', 'enterManualLocationCancelled'],
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      location: {
        name: '',
        address: {
          street_number: '',
          street_name: '',
          suburb: '',
          city: ''
        }
      }
    }
  },
  created() {
    if (!this.locationData) {
      return;
    }

    if (this.locationData.name) {
      this.location.name = this.locationData.name;
    }
    if (this.locationData.address.data.street_number) {
      this.location.address.street_number = this.locationData.address.data.street_number;
    }
    if (this.locationData.address.data.street_name) {
      this.location.address.street_name = this.locationData.address.data.street_name;
    }
    if (this.locationData.address.data.suburb) {
      this.location.address.suburb = this.locationData.address.data.suburb;
    }
    if (this.locationData.address.data.city) {
      this.location.address.city = this.locationData.address.data.city;
    }
  },
  methods: {
    onCancel() {
      this.$emit('enterManualLocationCancelled');
    },
    onConfirmForm() {
      // Validate fields
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$emit('enterManualLocationConfirmed', this.location);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
